import { maskPartialLocal } from './format';

/**
 * `s729` (жалоба 07.10.2026): менеджер набрала номер, оператор связи за четыре секунды ответил
 * «486 Busy Here», а пульт показал «Номер неизвестен» и красную строку
 * «Отказ: 486 Busy Here (subscriber_busy)» — ни номера, ни слов, что это ответ линии, а не поломка
 * рабочего места.
 *
 * Отказ линии — это исход ОДНОЙ попытки: в строке есть номер и то, что ответил оператор. Код «486»
 * не доказывает, что человек говорит по телефону: так же оператор отвечает на сброшенный звонок.
 */
export function tekstOtkazaLinii(nomer: string, kod: number, fraza: string, prichina?: string | null): string {
  const komu = maskPartialLocal(nomer);
  const otvet = `${kod} ${fraza}`.trim() + (prichina ? `, ${prichina}` : '');

  if (kod === 486 || kod === 600) {
    return `Не дозвонились до ${komu}: оператор связи ответил «занято» — абонент говорит или сбросил звонок (${otvet}).`;
  }

  // `s813` (14.10.2026): 11:28–11:38 станция потеряла регистрацию у МегаФона на всех линиях, на
  // набор она сама отвечала «503 Service Unavailable» (GATEWAY_DOWN), а пульт писал «оператор
  // связи отклонил звонок». Текст — слово владельца. «503 No line assigned» — наш маршрут
  // «рабочее место без линии», к связи с оператором отношения не имеет.
  if (kod === 503 && fraza !== 'No line assigned') {
    return `Не дозвонились до ${komu}: нет связи с МегаФоном — наберите ещё раз через пару минут.`;
  }

  return `Не дозвонились до ${komu}: оператор связи отклонил звонок (${otvet}).`;
}

/**
 * Что из строк пульта идёт в колокол шапки. Отказ линии туда не идёт: это не неисправность
 * телефона, а красный счётчик в шапке держался бы до следующего набора.
 */
export function trevogiTelefona(stroki: string[], otkaz: string | null): string[] {
  return otkaz === null ? stroki : stroki.filter(stroka => stroka !== otkaz);
}
